<div class="modal fade show" role="dialog" tabindex="-1" style="display: block;">
  <div class="modal-dialog" role="document" style="min-width: 90vw; width: 100%;">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title"> {{isEdit ? 'Edit': 'New'}} Group </h5>
        <button class="close" (click)="closePopup(content)"><i class="fa fa-times" aria-hidden="true"></i></button>
      </div>
      <div class="modal-body">
        <div *ngIf="loader">
          <div id="global-loader">
              <img src="./assets/img/loaders/loader.svg" class="loader-img" alt="Loader">
          </div>
      </div>
        <div class="row">
          <div class="col-3 mt-0">
            <label class="alignment color_theme">Group Name<sup class="red-star">*</sup></label>
            <input [(ngModel)]="groupName" (keypress)="validateName($event);" (ngModelChange)="eneteredGroupName() " placeholder="Enter Display Name"
              class="form-control" />
          </div>
          <!-- <div class="col-3 mt-0 multi-select-css">
            <label class="alignment">Devices<sup class="red-star">*</sup></label>
          <angular2-multiselect  id="kpi-dropdown" name="kpi-dropdown" [data]="edgeDevicesList" class="hide_checkbox-select data_modelClas"
          [(ngModel)]="selectedDevicesList" (onSelectAll)="ChangeDevices($event)" (onDeSelectAll)="ChangeDevices($event)"
          (onDeSelect)="ChangeDevices($event)" (onSelect)="ChangeDevices($event)" [settings]="deviceSettings">
        </angular2-multiselect>
          </div> -->
          <div class="col-3 mt-0">
            <label class="alignment color_theme">MNO MAP</label>
            <ng-select [items]="bandTemplatesList" [searchable]="true" bindLabel="template_name" bindValue="_id"
              placeholder="Enter Map Type" [(ngModel)]="mnoMapping" (change)="changeTemplate($event, templateChangeConfirmPopup); changeEvent()" required>
            </ng-select>
            <!-- (search)="onSearch($event)" -->
          </div>
          <!-- <div class="col-3 mt-0" *ngIf="!isEdit">
            <label class="alignment">Set APN</label>
            <input [(ngModel)]="apnName" (change)="changeEvent()" class="form-control" placeholder="Enter APN" />
          </div> -->
        
        <div class="col-6" *ngIf="mnoMapping">
          <label class="alignment">Bands</label>
          <div class=" band_cards">
            <label class="band_name"
              *ngIf="selectedMnoTemplate?._source?.bands?.bands_4g && selectedMnoTemplate?._source?.bands?.bands_4g.length !=0">4G
              :
              <span *ngFor="let band of selectedMnoTemplate?._source?.bands?.bands_4g" class="groupBadge">
                {{band}}
              </span>
            </label>
            <br
              *ngIf="selectedMnoTemplate?._source?.bands?.bands_4g && selectedMnoTemplate?._source?.bands?.bands_4g.length !=0">
            <label class="band_name"
              *ngIf="selectedMnoTemplate?._source?.bands?.bands_5g && selectedMnoTemplate?._source?.bands?.bands_5g.length !=0">5G
              :
              <span *ngFor="let band of selectedMnoTemplate?._source?.bands?.bands_5g" class="groupBadge">
                {{band}}
              </span>
            </label>
            <br
              *ngIf="(selectedMnoTemplate?._source?.bands?.bands_5g && selectedMnoTemplate?._source?.bands?.bands_5g.length !=0) || (selectedMnoTemplate?._source?.bands?.bands_4g && selectedMnoTemplate?._source?.bands?.bands_4g.length !=0)">
            <label class="band_name"
              *ngIf="selectedMnoTemplate?._source?.bands?.bands_nsa_5g && selectedMnoTemplate?._source?.bands?.bands_nsa_5g.length !=0">NSA
              5G :
              <span *ngFor="let band of selectedMnoTemplate?._source?.bands?.bands_nsa_5g" class="groupBadge">
                {{band}}
              </span>
            </label>
          </div>
        </div>
      </div>
        <div class="custome-picklist">
          <p-pickList (change)="pickListChange($event)" targetHeader="#sourceHeader" sourceHeader="#sourceHeader"
            (onMoveAllToSource)="pickListChange($event)" (onMoveAllToTarget)="pickListChange($event)"
            (onMoveToTarget)="pickListChange($event)" (onMoveToSource)="pickListChange($event)" keepSelection="true" stripedRows="true"
            [source]="sourceProducts" [target]="targetProducts" [dragdrop]="false" [responsive]="true" showSourceFilter="true"
            [sourceStyle]="{'height':'300px'}" [targetStyle]="{'height':'300px'}" filterBy="device_name_id"
            sourceFilterPlaceholder="Search by Device Name / Device Id / Imei" targetFilterPlaceholder="Search by Device Name / Device Id / Imei ">
            <ng-template pTemplate="sourceHeader">
              <div>Available <span class="badge bg-primary rounded-pill ms-1 me-2"> {{sourceProducts?.length}}</span>
                Fully Supported <span class="badge bg-success rounded-pill ms-1 me-2">{{fully?.length}}</span>
                Partially Supported <span class="badge bg-warning rounded-pill ms-1 me-2">{{Partially?.length}}</span>
                Not Supported <span class="badge bg-dark rounded-pill ms-1" style="color: #000;"> {{none.length}}</span>
              </div>
            </ng-template>
            <ng-template pTemplate="targetHeader">
              <div>Selected <span class="badge bg-primary rounded-pill ms-1 me-2"> {{targetProducts?.length}}</span>
                Fully Supported <span class="badge bg-success rounded-pill ms-1 me-2">{{selectedFully?.length}}</span>
                Partially Supported <span
                  class="badge bg-warning rounded-pill ms-1 me-2">{{selectedPartially?.length}}</span>
                Not Supported <span class="badge bg-dark rounded-pill ms-1" style="color: #000;">
                  {{selectednone.length}}</span>
              </div>
            </ng-template>
            <ng-template let-product pTemplate="item">
              <div class="product-item">
                <div class="product-list-detail">
                  <h5 class="mb-2 band_name">{{ product?._id  }} <span class="product-category"
                      *ngIf="product?.device_name">(
                      {{product?.device_name}} )</span></h5>
                </div>
                <div class="product-list-action">
                  <p class="imei_clas">IMEI: {{product?.name}}</p>
                  <p class="m-0">
                    <span *ngIf="product?.bands_4g && product?.bands_4g.length !=0">
                      <label class="band_name"><span class="span5g">4G : </span>
                        <span *ngFor="let band of product?.bands_4g" [ngClass]="setSourceBg(band,product,'4G')"
                          class="groupBadge">
                          {{band}}
                        </span>
                      </label>
                      <br>
                    </span>
                    <span *ngIf="product?.bands_5g && product?.bands_5g.length !=0">
                      <label class="band_name"><span  class="span5g">5G :</span>
                        <span *ngFor="let band of product?.bands_5g" [ngClass]="setSourceBg(band,product,'5G')"
                          class="groupBadge">
                          {{band}}
                        </span>
                      </label><br>
                    </span>
                    <span *ngIf="product?.bands_nsa_5g && product?.bands_nsa_5g.length !=0">
                      <label class="band_name"><span  class="span5g">NSA 5G : </span>
                        <span *ngFor="let band of product?.bands_nsa_5g" [ngClass]="setSourceBg(band,product,'NSA5G')"
                          class="groupBadge"> {{band}}
                        </span>
                      </label>
                    </span>
                  </p>
                </div>
              </div>
            </ng-template>
          </p-pickList>
        </div>
      </div>
      <div class="modal-footer">
        <button class="btn btn-danger" (click)="closePopup(content)">Cancel</button>
        <button class="btn btn-primary" color="primary" (click)="createRecord()"
          [disabled]="buttonDisabled "> {{isEdit ? 'Update' : 'Save'}}
        </button>
      </div>
    </div>
  </div>
</div>
<ng-template #content let-modal>
	
	<div class="modal-body">
        <div class="mt-4" style="text-align: center">
            <h5>You haven't saved the data, do you want to discard it?</h5>           
	</div>
    </div>
	<div class="modal-footer">
		<button type="button" class="btn btn-danger width75"  (click)="modal.close('Save click')">Cancel</button>
		<button type="button" class="btn btn-primary width75" (click)="modal.close('Save click'); closePopup('')">Yes</button>

	</div>
</ng-template>


<ng-template #templateChangeConfirmPopup let-modal>
	
	<div class="modal-body">
        <div class="mt-4" style="text-align: center">
          <h4 >MNO Map Modification/Deletion will effect the device band lock</h4>
           
	</div>
    </div>
	<div class="modal-footer">
		<button type="button" class="btn btn-danger width75"  (click)="modal.close(); cancelPopup() ">Cancel</button>
		<button type="button" class="btn btn-primary width75" (click)="modal.close(); proceed()">Proceed</button>

	</div>
</ng-template>
